import { writable } from 'svelte/store';

let basket = [];

export const basketList = writable(basket || []);
